<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :style="{ width: '400px' }"
    :header="t('myLists.manage.actions.listDelete.formTitle')"
  >
    <div class="p-fluid">
      <p>{{ t('myLists.manage.actions.listDelete.text') }}</p>
      <p class="font-semibold mt-2">
        {{ currentPayload?.listName }}
      </p>
    </div>
    <template #footer>
      <SpmButton
        :label="t('myLists.manage.actions.listDelete.rejectLabel')"
        icon="pi pi-times"
        class-style="p-button p-button-secondary"
        @click="close"
      />
      <SpmButton
        :label="t('myLists.manage.actions.listDelete.acceptLabel')"
        icon="pi pi-check"
        class-style="p-button p-button-danger"
        @click="confirm"
      />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import type { ListActionPayload, DeleteListResult } from './types';

export default defineComponent({
  name: 'DeleteListAction',

  components: {
    Dialog,
    SpmButton,
  },

  emits: ['confirm'],

  setup(_, { emit, expose }) {
    const { t } = useI18n();

    // Internal state
    const isVisible = ref(false);
    const currentPayload = ref<ListActionPayload | null>(null);

    /**
     * Open the dialog with the given payload
     */
    const open = (payload: ListActionPayload) => {
      currentPayload.value = payload;
      isVisible.value = true;
    };

    /**
     * Close the dialog
     */
    const close = () => {
      isVisible.value = false;
      currentPayload.value = null;
    };

    /**
     * Confirm the action and emit result
     */
    const confirm = () => {
      if (!currentPayload.value) return;

      const result: DeleteListResult = {
        listId: currentPayload.value.listId,
        listName: currentPayload.value.listName,
      };

      emit('confirm', result);
      close();
    };

    // Expose open method for parent component
    expose({ open });

    return {
      t,
      isVisible,
      currentPayload,
      close,
      confirm,
    };
  },
});
</script>
